import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import CareersPage from './pages/CareersPage';
import JobDetailsPage from './pages/JobDetailsPage';
import ITServicesPage from './pages/ITServicesPage';
import DesignEngineeringPage from './pages/DesignEngineeringPage';
import SalesMarketingPage from './pages/SalesMarketingPage';
import DataEngineeringPage from './pages/DataEngineeringPage';
import AISolutionsPage from './pages/AISolutionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import CookiePolicyPage from './pages/CookiePolicyPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/:id" element={<JobDetailsPage />} />
          <Route path="/services/it" element={<ITServicesPage />} />
          <Route path="/services/design-engineering" element={<DesignEngineeringPage />} />
          <Route path="/services/sales-marketing" element={<SalesMarketingPage />} />
          <Route path="/services/data-engineering" element={<DataEngineeringPage />} />
          <Route path="/services/ai-solutions" element={<AISolutionsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
